/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { Cell, Legend, Pie, PieChart, Tooltip } from "recharts";

import { IDemographicsChartProps } from "../IDemographicsChartProps";
import { noDataStyle, pieChartStyle, COLORS } from "./DemographicsPieChart.styles";

export function DemographicsPieChart(props: IDemographicsChartProps) {
  const { data, title } = props;

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    _,
    payload,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius + 15) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    // If slice is too small, don't render label. User can still hover for tooltip.
    return percent < 0.05 ? (
      <></>
    ) : (
      <text x={x} y={y} fill="white" textAnchor={"middle"} dominantBaseline="middle" fontSize={20}>
        {payload.value}
      </text>
    );
  };

  return (
    <div style={pieChartStyle}>
      <h5>{title}</h5>
      {data && data.length > 0 ? (
        <PieChart width={400} height={300}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            fill="#8884d8"
            label={renderCustomizedLabel}
            labelLine={false}
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend verticalAlign="bottom" width={350} />
          <Tooltip />
        </PieChart>
      ) : (
        <div style={noDataStyle}>No Data</div>
      )}
    </div>
  );
}
